module.exports = __webpack_public_path__ + "distribution/img/no-data.068a2536.png";